<template>
<div>
  <nav class="navbar navbar-expand-sm navbar-dark bg-primary bg-gradient  d-none d-md-block d-lg-block d-xl-block d-xxl-block">
    <div class="d-flex justify-content-center">
      <img src="~@/assets/left.jpg" class=""/>
    </div>
    <div class="d-flex justify-content-center">
      
      <ul class="navbar-nav nav-pills"> 
        <li class="nav-item">
          <router-link to="/bomquery" :class="{'nav-link':true,'active':ActiveMenu=='/bomquery'?true:false}">Bill of Material Query</router-link> 
        </li>
        <li class="nav-item">
          <router-link to="/flatbom" :class="{'nav-link':true,'active':ActiveMenu=='/flatbom'?true:false}">Where Used Query</router-link> 
        </li>
          
      </ul>
    </div>
  </nav>
  <nav class="navbar navbar-expand-sm bg-dark navbar-dark d-block d-sm-none">
    <div class="d-flex justify-content-center">
      <ul class="navbar-nav nav-pills">
        <li class="nav-item pr-3">
           
        </li> 
        <!-- <li class="nav-item pt-2-5">
          <router-link to="/" class="nav-link active">Home</router-link> 
        </li>
        
        <li class="nav-item pt-2-5" v-for="(item, index) in userMenu[0].items" :key="item.heading">
          <router-link :to="menuHeading(index)" class="nav-link">{{item.heading}}</router-link> 
        </li> 
        <li class="nav-item pt-2-5">
          <router-link to="/logout" class="nav-link">Logout</router-link> 
        </li> -->
      </ul>
    </div>
  </nav>

</div>
</template>

<script> 
export default {
  name:"topBar",
  computed: {
    ActiveMenu() {
      return this.$store.state.navSystem.navSystem.urlTo;
    } 
  },
  data() {
    return {
    };
  },
  methods:{ 
    menuHeading(index){
      return `/menu/0/${index}`
    }
  } 
}
</script>
<style>
.headerImg{
  max-width: 80px;
  min-width: 25px;
}
.pt-2-5, .pt-2-5 {
    padding-top: 0.8rem!important;
}
.nav-link.active{
  font-weight:900 !important;
}
.nav-link{
  font-weight: normal !important;
}
</style>